// Opens the global AI assistant drawer from anywhere (the shell listens to this event).
export const ASSISTANT_EVENT = "ds:assistant";

export function openAssistant(prompt?: string): void {
  window.dispatchEvent(new CustomEvent(ASSISTANT_EVENT, { detail: { prompt } }));
}
